//获取cookie、
export function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) return arr[2];
  else return null;
}

//设置cookie,增加到vue实例方便全局调用    //expiredays==null时关闭浏览器自动清除cookie
export function setCookie(c_name, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie =
    c_name +
    "=" +
    escape(value) +
    (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
}

//删除cookie
export function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

export function gethttps() {
  // var https ='https://www.decaisoft.com:8090/img'
  var https = "https://www.decaisoft.com:443/img";
  // const https = "http://139.9.58.205:8077/tydFile/";

  return https;
}

export function getImageUrl() {
  // var https ='https://www.decaisoft.com:443/img/demay/' //测试服务器图片路径
  var https = "https://www.decaisoft.com:443/img/demay_formal/"; //线上服务器图片路径
  // const https = "http://139.9.58.205:8077/tydFile/";
  return https;
}


// WEBPACK FOOTER //
// ./src/utils/utils.js